<template>
    <div v-if="data" class="ur-data-grid__edit__element__message--error"
            :style="tooltipStyle" ref="tooltips">
        {{data.text}}
    </div>
</template>


<script>
export default {
    name  : 'urDataGridContentTooltipItem',
    inject: ['gridInfo'],
    props : {
        data : {type:Object, default: null}
    },
    computed: {
        // [COMPUTED] Data, grid total count
        pCnt() {
            // 0. prepare data
            const COLS = this.gridInfo.cols;
            const $src = this.gridInfo.refs.scrollWrapper;
            const FRZ  = this.gridInfo.vars_freezeWidth,
                  SRW  = $src.getBoundingClientRect().width;
            const isScroll = SRW+FRZ < this.gridInfo.vars_tableWidth;
            // 1. Check is 0
            if(isScroll) {return 0;}
            // 2. Calculate
            return COLS.reduce((acc, f)=> acc+(!f.__width&&!f.hide?1:0), 0);
        },
        // [COMPUTED] Data, grid total count
        pOff() {
            // 0. prepare data
            const opts = this.gridInfo.opts;
            const COLS = this.gridInfo.cols;
            const $src = this.gridInfo.refs.scrollWrapper;
            const FRZ  = this.gridInfo.vars_freezeWidth,
                  SRW  = $src.getBoundingClientRect().width;
            const isScroll = SRW+FRZ < this.gridInfo.vars_tableWidth;
            // 1. Check is 0 
            if(isScroll) {return 0;}
            // 2. Calculate
            var pOff = COLS.reduce((acc, f)=> acc+(f.hide?1:f.__width), 0);
            if(opts.selectCheck) {
                pOff += opts.selectCheckboxWidth
            }
            return pOff;
        },
        // [COMPUTED] Style, Style of tooltips
        tooltipStyle() {
            const data = this.data
                , fil = data.field
                , row = data.row
                , gi = this.gridInfo
                , opts = gi.opts;
            const $src = this.gridInfo.refs.scrollWrapper;
            const FRZ  = this.gridInfo.vars_freezeWidth,
                  SRW  = $src.getBoundingClientRect().width;
            const dWIDTH = this.gridInfo.opts.defaultFieldWidth;
            const isScroll = SRW+FRZ < this.gridInfo.vars_tableWidth;
            
            // 2.1 Check start/end/selcted
            let stx=fil.__pox,
                stb=fil.__pob; // Start 
            let slx=fil.__width||0,
                slb=fil.__width?0:1; // Selected
            // 2.2 And need blank?
            let pCnt=this.pCnt, pOff=this.pOff;
            if(isScroll) {
                stx+= dWIDTH*stb; stb=0;
                slx+= dWIDTH*slb; slb=0;
            }
            //------------------------------------
            let style = {};
            var idx = row.__idx + 1;
            if(!!this.gridInfo.vars_currEditRow) {
                const editRow = this.gridInfo.vars_currEditRow;
                if(editRow.__id !== row.__id && editRow.__idx === null){
                    idx++;
                }
            }
            style['top'] = (idx*opts.rowHeight)+'px';
            if(data.field.__frz) {
                style['left'] = `${stx}px`;
            } else if(stb>0){
                style['left'] = `calc(${100/pCnt*stb}% - ${(pOff-(FRZ||0))/pCnt*stb}px + ${stx-(FRZ||0)}px)`;
            } else {
                style['left'] = `${stx - (FRZ||0)}px`;
            }
            if(slb+stb > 0) {
                style['width'] = `calc(${100/pCnt*slb}% - ${(pOff-(FRZ||0))/pCnt*slb}px + ${slx}px)`;
            } else {
                style['width'] = `${slx}px`;
            }
            return style
        }
    },
    mounted() {
        this.$nextTick(()=>{this.shake()});
    },
    methods: {
        shake() {
            let em = this.$refs.tooltips;
            if(!em) return;
            em.classList.add('ur-validator--shake');
            setTimeout(()=>em.classList.remove('ur-validator--shake'), 500);
        }
    }
    
}

</script>